export default "__VITE_ASSET__CATaP_Vz__"